<script lang="ts" setup>
import ProblemPresentationCard from '../ProblemPresentation/ProblemPresentationCard.vue';

defineProps<{
  imageNumber: InstanceType<
    typeof ProblemPresentationCard
  >['$props']['imageNumber'];
}>();
</script>

<template>
  <ProblemPresentationCard :image-number="imageNumber">
    <template #titleText>
      iDeCoと<span :class="$style['card__text--accent']"
        >他の年金制度の違い</span
      >って何？
    </template>
    <template #detail>
      iDeCoと他の年金制度って何が違うの？
      自分にとってどれが最適か、アドバイスが欲しい。
    </template>
  </ProblemPresentationCard>
</template>

<style lang="scss" module>
.card {
  &__text {
    &--accent {
      color: $color-text-and-object-accent-primary;
    }
  }
}
</style>
